import { animate, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger, SUPPORTS_CLIP } from '../motion-tokens.js';

export const logosV1 = (el) => {
    // v1: carruél infinito — PRIMARIO: clipPath cortina izq→der revela el track.
    const track = el.querySelector('.logos-track, .logo-carousel, [class*="logos-track"]');
    if (!track) return null;

    // Estado inicial forzado (previene FOVC)
    track.style.opacity = '0';

    if (SUPPORTS_CLIP) {
        return animate(track, {
            clipPath:  ['inset(0 100% 0 0)', 'inset(0 0% 0 0)'],
            opacity:   [0, 1],
            duration:  resolveDuration(DURATION.slow),
            ease:      EASE.snappy,
        });
    } else {
        return animate(track, {
            opacity:  [0, 1],
            duration: resolveDuration(DURATION.slow),
            ease:     EASE.refined,
        });
    }
};

export const logosV2 = (el) => {
    // v2: grid estático — PRIMARIO: grayscale→color. SECUNDARIO: opacity.
    const logos = el.querySelectorAll('.logo-item, .logo-card, [class*="logo-item"]');
    if (!logos.length) return null;

    // Estado inicial forzado (previene FOVC)
    logos.forEach(l => { l.style.opacity = '0'; l.style.filter = 'grayscale(1) blur(2px)'; });

    return animate(logos, {
        opacity:   [0, 1],
        // Primario: de gris a color (la transformación perceptual es el momento memorable)
        filter:    ['grayscale(1) blur(2px)', 'grayscale(0) blur(0px)'],
        delay:     stagger(resolveStagger(STAGGER.fast), { from: 'center' }), // ola desde el centro
        duration:  resolveDuration(DURATION.slow),
        ease:      EASE.refined,
    });
};
